import IShift from '@/models/Shifts/IShift';

export default (value: IShift) => {
    const start = new Date(value.startAt)
    const end = new Date(value.endAt)
    return start.toLocaleDateString(['en-GB'], {month: 'long', day: '2-digit', year: 'numeric' }) + "  (" + start.toLocaleTimeString("en-GB").replace(":00", "") + "-" + end.toLocaleTimeString("en-GB").replace(":00", "") + ")"
} 